import Store from "@/Services/Store";

export default {
  setupStoreWatchers() {
    Store.watch(
      state => state.products,
      newProducts => {
        if (newProducts.length === 0) return;

        const products = newProducts.filter(p => p.quantity > 0).map(p => ({id: p.id, quantity: p.quantity}));
        window.localStorage.setItem('centralAdminOrderForm.products', JSON.stringify(products));

        this.updateLocalStorageExpiration();
      },
      {deep: true}
    );

    Store.watch(
      state => state.form,
      newForm => {
        window.localStorage.setItem('centralAdminOrderForm.form', JSON.stringify(newForm));

        this.updateLocalStorageExpiration();
      },
      {deep: true}
    );
  },

  loadDataFromLocalStorage() {
    if (this.localStorageHasExpired()) {
      this.clear();
      return;
    }

    const form = window.localStorage.getItem('centralAdminOrderForm.form');
    if (form) Store.state.form = JSON.parse(form);

    let products = window.localStorage.getItem('centralAdminOrderForm.products');
    if (products) {
      products = JSON.parse(products);

      products.forEach(product => {
        const index = Store.state.products.findIndex(p => p.id == product.id);

        Store.state.products[index].quantity = product.quantity;
      });
    }
  },

  hasSaved(key) {
    return window.localStorage.getItem(`centralAdminOrderForm.${key}`) !== null;
  },

  updateLocalStorageExpiration() {
    const expiresAfter = 3600 * 12; // 12 hours
    const expiresAt    = Math.round(Date.now() / 1000) + expiresAfter;

    window.localStorage.setItem('centralAdminOrderForm.expiresAt', expiresAt.toString());
  },

  localStorageHasExpired() {
    const expiresAt = window.localStorage.getItem('centralAdminOrderForm.expiresAt');

    return Math.round(Date.now() / 1000) > Number(expiresAt);
  },

  clear() {
    window.localStorage.removeItem('centralAdminOrderForm.form');
    window.localStorage.removeItem('centralAdminOrderForm.products');
    window.localStorage.removeItem('centralAdminOrderForm.expiresAt');
  },
};
